import React from "react";
import "./GuideGettingStarted.css";
import GuideHeader from "../Guide/GuideHeader";

const GuideGettingStarted = () => {
  return (
    <div className="guide-page">
      {/* Hero Section */}
   <GuideHeader headingLevel="div" />

      {/* Content Section */}
      <section className="guide-content">
        <h1>10 email marketing do’s and don’ts</h1>
        <p className="intro-text">
          Welcome to the first instalment of the EmailOctopus guide to email
          marketing. Through our guide, we’ll share with you all our knowledge
          to help take you from an email marketing novice to an expert.
        </p>
        <p className="intro-text">
          This first article covers the do’s and don’ts of email marketing.
          There are hundreds of myths, outdated tactics and falsehoods which can
          have a negative impact on your campaigns. These tips will help point
          you in the right direction, ensuring you don’t make damaging mistakes
          which might impact the success of your emails.
        </p>

        <div className="dos-donts">
          <div className="dos">
            <h3>Do</h3>
            <ul>
              <li>
                ✅ Grow your list organically. Encourage subscribers to opt in
                to receive your emails and build your list over time.
              </li>
              <li>
                ✅ Set up an automated welcome flow for new subscribers so they
                know what sort of content they’ll be receiving from you.
              </li>
              <li>
                ✅ Use preview text to increase your open rate by telling
                subscribers know what’s in your email.
              </li>
              <li>
                ✅ Personalise your subject lines using merge tags to increase
                your open rate.
              </li>
              <li>
                ✅ Use automated email workflows to take your customers on a
                journey.
              </li>
              <li>
                ✅ Test to find out the best time of day to send emails and get
                a good open rate.
              </li>
              <li>
                ✅ Make sure your grammar and spelling are impeccable – and
                always check your links work.
              </li>
              <li>
                ✅ Pay close attention to your campaign reports and understand
                customer engagement to tailor subsequent emails.
              </li>
              <li>
                ✅ Create separate lists for subscribers who are interested in
                specific products or services.
              </li>
              <li>
                ✅ Send a test email to yourself and a couple of colleagues
                before sending your campaign out.
              </li>
            </ul>
          </div>

          <div className="donts">
            <h3>Don’t</h3>
            <ul>
              <li>
                ❌ Send cold emails to people who haven’t asked to receive them,
                or buy lists of contacts.
              </li>
              <li>❌ Collect email addresses and not use them.</li>
              <li>
                ❌ Send an email without the preview text completed. Subscribers
                may not know what to expect and will be less likely to open.
              </li>
              <li>
                ❌ Send “one size fits all” emails that don’t feel personalised
                or relevant to your audience.
              </li>
              <li>
                ❌ Send infrequent, one-off emails and lose touch with your
                subscriber base.
              </li>
              <li>❌ Send your emails randomly at any time of the day.</li>
              <li>
                ❌ Send emails without proofreading and checking everything works
                as it should.
              </li>
              <li>
                ❌ Keep doing the same things without testing and learning what
                your customers will respond to best.
              </li>
              <li>
                ❌ Send all your products and services to a large generic list,
                regardless of your subscribers’ interests.
              </li>
              <li>
                ❌ Send your email to your subscriber base without first
                checking it on both your computer and phone.
              </li>
            </ul>
          </div>
        </div>

        <div className="next-step">
          <p>It’s time to send your first email!</p>
          <p className="next-link">
            Read how to <a href="/guide">write a great subject line →</a>
          </p>
        </div>
      </section>

      {/* Start Section */}
      <section className="guide-start">
        <h2>Start for free today</h2>
        <p>
          Sign up and send your first campaign in minutes. No credit card
          required.
        </p>
      </section>
    </div>
  );
};

export default GuideGettingStarted;
